declare namespace $ {

	type $shm_hitalama_text_table_body__sub_shm_hitalama_text_table_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_table['rows'] >
		,
		ReturnType< $shm_hitalama_text_table_body['sub'] >
	>
	export class $shm_hitalama_text_table extends $mol_grid {
		Table( ): $shm_hitalama_text_table_body
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map